import { NAMES } from "@/config/config";
import { defineAsyncComponent } from "vue";

export default [
  {
    path: "/home/:id",
    name: "home",
    component: () => import("@/views/home/homeIndex.vue"),
    meta: {
      title: "首页",
      keepAlive: true,
    },
    children: [],
  },
  // {
  //   path: "/approveCloud/:id",
  //   name: NAMES.APPROVE,
  //   meta: {
  //     iframeComponent: defineAsyncComponent(() => import("@/views/approveCloud/approveCloud.vue")),
  //     title: "审批云",
  //     keepAlive: true,
  //   },
  //   children: [],
  // },
  {
    path: "/budgetCloud/:id",
    name: NAMES.BUDGET,
    component: () => import("@/views/budgetCloud/budgetCloud.vue"),
    meta: {
      title: "预算云",
      keepAlive: true,
    },
  },
  {
    path: "/financialCloud/:id",
    name: NAMES.FINANCIAL,
    component: () => import("@/views/financialCloud/financialCloud.vue"),
    meta: {
      title: "财务云",
      keepAlive: true,
    },
  },
  {
    path: "/financialStatements/:id",
    name: NAMES.FINANCIAL_LIST,
    meta: {
      iframeComponent: defineAsyncComponent(() => import("@/views/financialStatements/financialStatements.vue")),
      title: "财务报表",
      keepAlive: true,
    },
    children: [],
  },
  {
    path: "/fiscalTaxAnalysis/:id",
    name: NAMES.FISCAL_ANALYSIS,
    component: () => import("@/views/fiscalTaxAnalysis/fiscalTaxAnalysis.vue"),
    meta: {
      title: "财税分析",
      keepAlive: true,
    },
  },
  {
    path: "/InvoicingIndex/:id",
    name: NAMES.PURCHASE,
    component: () => import("@/views/Invoicing/InvoicingIndex.vue"),
    meta: {
      title: "进销存",
      keepAlive: true,
    },
  },
  {
    path: "/enterpriseInformation/:id",
    name: NAMES.COMPANY,
    component: () => import("@/views/enterpriseInformation/enterpriseInformation.vue"),
    meta: {
      title: "企业信息",
      keepAlive: true,
    },
  },
];
